import AuthStore from "../store/AuthStore";
import LicenceDataSource, { getSmartFetchData, ILicenceStoreConfig, ISmartFetchConfig } from "./LicenceDataSource";
import ArrayStore, { Options } from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";

export default class ReshapeDataSource {
    itemList: any[];
    listStore: ArrayStore<any, any>;
    dataSource: DataSource<any, any>;
    constructor(options?: Options<any, any>) {
        this.itemList = [];
        const opts = Object.assign(            
            {
                key: 'Id',
                data: this.itemList,
/*
                onInserted: (changes) => {
                    //                console.log(changes);
                },
                onRemoved: (key) => {
                    //                console.log(key);
                },
*/
            },
            options || {}
        );
        this.listStore = new ArrayStore(
          opts
        );
        this.dataSource = new DataSource({
            store: this.listStore,
            reshapeOnPush: true,
        });
    }
    async getDataFromQueryAsync(config: ILicenceStoreConfig) {
        const response = await getSmartFetchData({
            authStore: config.authStore,
            url: LicenceDataSource.getUrlStr(config.url, config.filter, config.includeTables),// urlObj.toString(),
            config: {},
            cacheDuration: config.cacheDuration ?? 0,
            returnDataAsNoObject: false,// config.loadMode == "raw",
        }
        );
        const data = response.data;
        return data;
    }
    getDataFromQuery(config: ILicenceStoreConfig) {
        const data = (async () => { await this.getDataFromQueryAsync(config); })();
        return data;
    }

    async reFillDataAsync (config: ILicenceStoreConfig) {
        const data = await this.getDataFromQueryAsync(config);
//        this.itemList.length = 0;
        this.listStore.clear();
        for (let item of data) {
            this.listStore.insert(item);
        }
        this.dataSource.reload();
        return data;
    }

    currentKeyOf(item) {
        const keyProps = this.listStore.keyOf(item);
        return keyProps;
    }

    reFillData (config: ILicenceStoreConfig) {
        const data = (async () => { await this.reFillDataAsync(config); })();
        return data;
    }

    clear() {
//        this.listStore.clear();
        this.itemList.length = 0;
        this.dataSource.reload();
    }
    reload() {
        this.dataSource.reload();
    }
    loadFrom(array) {
        this.listStore.clear();
        for (let item of array) {
            this.listStore.insert(item);
        }
        this.dataSource.reload();
    }
    insert(item) {
        this.listStore.insert(item);
        this.dataSource.reload();
    }
    remove(item) {
//        this.listStore.remove(item["Id"]);
        const keyProps = this.currentKeyOf(item);
        this.listStore.remove(keyProps);
        this.dataSource.reload();
    }
    update(item) {
//        this.listStore.update(item["Id"], item);
        const keyProps = this.currentKeyOf(item);
        this.listStore.update(keyProps, item);
        this.dataSource.reload();
    }
}
